export default "__VITE_ASSET__e8c22616__"